import type {
  IValidationError,
  TFunction,
  ValidationErrorResponse,
} from '@wyz/types';
import { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import {
  CommonErrorCodesLookup,
  PurchaseErrorCodesLookup,
} from '~/common/helpers';
import { CommonErrorCodesEnumType } from '~/common/types';
import { PurchaseErrorCodeKeys } from '~/purchase/types';

export const setFormErrors = <TFieldValues extends FieldValues>({
  setError,
  errors = [],
}: {
  setError: UseFormSetError<TFieldValues>;
  errors?: IValidationError[];
}): void => {
  errors.forEach(({ propertyPath, errors }) => {
    setError(
      propertyPath as Path<TFieldValues>,
      {
        type: 'manual',
        message: errors[0],
      },
      {
        shouldFocus: true,
      },
    );
  });
};

export const formatValidationErrors = (
  errors: ValidationErrorResponse<
    CommonErrorCodesEnumType | PurchaseErrorCodeKeys
  >['errors'],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: TFunction<any>,
) => {
  return errors.map((item) => {
    return {
      ...item,
      errors: item.errors.map((errorMessage) => {
        if (errorMessage in CommonErrorCodesLookup) {
          return t(
            CommonErrorCodesLookup[errorMessage as CommonErrorCodesEnumType],
          );
        }
        return t(
          PurchaseErrorCodesLookup[errorMessage as PurchaseErrorCodeKeys],
        );
      }),
    };
  });
};
